<!-- The right column, for the selected card. Empty and quiet when nothing is selected. -->

<div class="mv-details" data-element="maven-details">

  <!-- The three sections are ALWAYS on screen, equal thirds of the column, edge to edge (owner,
       2026-09-11). Without a selected card each is an empty box; the content inside is what comes
       and goes. Each body scrolls on its own, with DevExtreme's scroll view, never native overflow. -->

    <!-- ---------- Summary: Pros | Cons, the two halves of the sketch ---------- -->
    <section class="d-sec" data-element="details-summary">
      <header class="d-hd">Summary</header>
      <div class="d-body d-body--summary">
      <dx-scroll-view>
      <ng-container *ngIf="this.hasCard">

      <div class="pros-cons">

        <div class="half pros" data-element="summary-pros">
          <div class="half-hd">PROS</div>

      <div class="d-row"><span>Best price</span><span data-element="summary-best-price"
        [class.credit]="this.card?.prices?.total > 0"
        [class.debit]="this.card?.prices?.total < 0">{{ this.bestPriceText }}</span></div>

          <!-- Cost per day is on the CARD, under its price (owner, vrequest 2026-09-13; replaces
               ruling D2, which kept it here). Not repeated in this list. -->

          <div class="d-row"><span>Expiration</span><span data-element="summary-date">{{ this.dateText }}</span></div>

          <!-- The adjustment types the package represents — `2B(C) + 2B(P)` — the same string as
               the card's Adjustment line (owner, 2026-09-21). Absent when none were delivered. -->
          <div class="d-row" *ngIf="this.adjustmentTypesText">
            <span>Adjustment</span><span data-element="summary-adjustment-types">{{ this.adjustmentTypesText }}</span>
          </div>

          <div class="d-row" *ngIf="this.callsDelivered">
            <span>Calls delivered</span><span data-element="summary-calls">{{ this.callsDelivered }}</span>
          </div>
          <div class="d-row" *ngIf="this.putsDelivered">
            <span>Puts delivered</span><span data-element="summary-puts">{{ this.putsDelivered }}</span>
          </div>

          <!-- The Proprietary Index Number slot was REMOVED here (owner, 2026-09-13). -->
        </div>

        <div class="half cons" data-element="summary-cons">
          <div class="half-hd">CONS</div>

          <!-- The report on THIS expiration date only; nothing at all when there is none
               (CR-20260921-001, owner ruling 2026-09-21). No "clear" line, no neighbour. -->
          <ng-container *ngIf="this.nearbyReports.length">
            <div class="cons-label">Economic reports</div>

            <div class="tier" *ngFor="let report of this.nearbyReports" data-element="summary-report">
              <b>{{ report.label }}</b><span>{{ report.text }}</span>
            </div>
          </ng-container>
        </div>

      </div>
      </ng-container>
      </dx-scroll-view>
      </div>
    </section>

    <!-- ---------- Trade orders: its own section, two big buttons side by side ---------- -->
    <section class="d-sec" data-element="details-orders">
      <header class="d-hd">Trade orders</header>
      <!-- No scroll view here: a row of buttons never overflows, and the body itself is the box the
           row centres in. -->
      <div class="d-body d-body--centre">
      <ng-container *ngIf="this.hasCard">

      <!-- Big punch buttons (owner, 2026-09-11): plain <button>s styled here, NOT dx-button - the
           widget's template wrappers defeated vertical centring three times. The unavailable
           reason rides on the button as its tooltip; no text lines in the section. -->
      <div class="punch-row">
        <button type="button" class="punch caps" data-element="btn-adjustment"
                [disabled]="!this.canOrder"
                [title]="this.cannotOrderReason || ''"
                (click)="this.onAdjustment()">
          <i class="fas fa-briefcase"></i>
          <!-- FIXED LABEL (owner, vrequest 2026-09-13): the glow says "sent", the text never changes. -->
          <span class="punch-text">Adjustment</span>
        </button>

        <!-- ONE control. The dialog carries the close, the opening and the regroup. -->
        <button type="button" class="punch caps" data-element="btn-hedges"
                [disabled]="!this.canOrder"
                [title]="this.cannotOrderReason || ''"
                (click)="this.onHedges()">
          <i class="fas fa-shield-alt"></i>
          <span class="punch-text">Hedges</span>
        </button>
      </div>
      <!-- NO lock hint here (owner, 2026-09-15, fourth look): the "no text lines in the section"
           rule of 2026-09-11 stands. The hint lives inside the two pop-ups, where the bar it
           replaces is; the dimmed cards say the rest. -->
      </ng-container>
      </div>
    </section>

    <!-- ---------- Next steps: a placeholder, but the three buttons of the sketch, in one line ---------- -->
    <section class="d-sec" data-element="details-next-steps">
      <header class="d-hd">Next steps</header>
      <!-- No scroll view here: a row of buttons never overflows, and the body itself is the box the
           row centres in. -->
      <div class="d-body d-body--centre">
      <ng-container *ngIf="this.hasCard">

      <!-- Three, each with the icon its label names (Font Awesome 5, already installed). -->
      <div class="punch-row">
        <button type="button" class="punch" data-element="btn-alerts" disabled>
          <i class="fas fa-bell"></i><span class="punch-text">Alerts</span>
        </button>
        <button type="button" class="punch" data-element="btn-messages" disabled>
          <i class="fas fa-envelope"></i><span class="punch-text">Messages</span>
        </button>
        <button type="button" class="punch" data-element="btn-harvest-orders" disabled>
          <i class="fas fa-hand-holding-usd"></i><span class="punch-text">Harvest Orders</span>
        </button>
      </div>
      </ng-container>
      </div>
    </section>

</div>

<!-- The two pop-ups this column hands its orders to. They write the after-state slots themselves;
     this lane writes none. -->
<!-- While another card is applied both pop-ups open READ-ONLY: their Copy / Regroup bar is replaced
     by the same lock hint shown under the buttons above (owner, 2026-09-15, CR-20260915-003). -->
<ets-adjustment-solution-popup #adjustmentPopup [lockHint]="this.lockHint"></ets-adjustment-solution-popup>
<ets-hg-transaction-popup #hedgesPopup [lockHint]="this.lockHint"></ets-hg-transaction-popup>
